<div class="row">
  <span style="width: 30%;">
    <div style="clear: both;">
      {{ translate('Direccion_catastro') }}
    </div>
    <span #mapSearch>
      <movisat-map-search style="float: left; width: 90%;" (mapSearch)="onMapSearch($event)">
      </movisat-map-search>
    </span>

    <jqxButton class="button" style="display: flex; margin: auto; cursor: pointer;"
      [hidden]="direccion?.catastro == null && ciudadano?.catastro == null" [height]="23" [title]="translate('Desvincular')"
      (onClick)="desvincularCatastro()">
        <i class="fa-solid fa-trash"></i>
    </jqxButton>
  </span>
  <span style="width: 40%;">

    <div style="clear: both;">
      {{ translate('Numero_de_catastro') }}
    </div>

    <jqxInput *ngIf="ciudadano" [(ngModel)]="ciudadano.numeroCatastro" [width]="'100%'">
    </jqxInput>

    <jqxInput *ngIf="direccion" [(ngModel)]="direccion.referenciaCatastral" [width]="'100%'">
    </jqxInput>
  </span>
  <span style="width: 30%;">
    <div style="clear: both;">
      {{ translate('Titular_catastro') }}
    </div>
    <jqxInput *ngIf="ciudadano" [value]="ciudadano.catastro?.titular" (onChange)="onChange($event, ciudadano)" [width]="'100%'">
    </jqxInput>

    <jqxInput *ngIf="direccion" [value]="direccion.catastro?.titular" (onChange)="onChange($event, direccion)" [width]="'100%'">
    </jqxInput>
  </span>
</div>
